import { useRef, useState } from "react"
import { DOWNLOAD_TYPES, INPUTS } from "hooks/budgeting/useDownloadBudgetConfig"

export const useBC3Options = ({ downloadBudgetConfig }) => {
  const tipo = DOWNLOAD_TYPES.BC3
  const config = downloadBudgetConfig[tipo] || {}

  const addCostsRef = useRef(null)
  const [addCosts, setAddCosts] = useState(config[INPUTS.USE_COSTS] ?? true)

  const [addMeasurements, setAddMeasurements] = useState(
    config[INPUTS.EXPORT_MEASUREMENTS] ?? true,
  )

  const [addDecompositions, setAddDecompositions] = useState(
    config[INPUTS.EXPORT_DECOMPOSITIONS] ?? true,
  )

  const [simpleMode, setSimpleMode] = useState(
    config[INPUTS.SIMPLE_MODE] ?? true,
  )

  return {
    addCostsRef,
    addCosts,
    setAddCosts,
    addMeasurements,
    setAddMeasurements,
    addDecompositions,
    setAddDecompositions,
    simpleMode,
    setSimpleMode,
  }
}
